import React from 'react';
import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { EventContentArg } from '@fullcalendar/core';

interface Props {
  eventInfo: EventContentArg;
}

export default function EventContent({ eventInfo }: Props) {
  const viewType = eventInfo.view.type;
  const isAllDay = eventInfo.event.allDay;
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const originalTimezone = eventInfo.event.extendedProps?.originalTimezone;
  const displayTimezone = eventInfo.event.extendedProps?.displayTimezone;
  
  // Only show timezone indicator for timed events
  const showTimezoneIndicator = !isAllDay && 
    originalTimezone && 
    displayTimezone && 
    originalTimezone !== displayTimezone;
  
  let monthlyViewTime = '';
  if (!isAllDay && eventInfo.event.start) {
    const zonedTime = utcToZonedTime(eventInfo.event.start, userTimezone);
    monthlyViewTime = format(zonedTime, 'h:mmaaa');
  }

  if (viewType === 'dayGridMonth' && isAllDay) {
    return (
      <div className="cursor-pointer overflow-hidden w-full p-0.5">
        <div className="flex items-center gap-1 text-gray-700 font-medium">
          <span className="truncate">{eventInfo.event.title}</span>
        </div>
      </div>
    );
  }
  
  if (viewType === 'dayGridMonth') {
    return (
      <div
        className="cursor-pointer overflow-hidden w-full p-0.5"
        style={{
          borderRadius: '4px',
          backgroundColor: eventInfo.backgroundColor,
        }}
      >
        <div className="flex items-center gap-1 text-gray-700 font-medium">
          {!isAllDay && monthlyViewTime && (
            <div className="font-bold">
              {monthlyViewTime}
            </div>
          )}
          <span className="truncate">{eventInfo.event.title}</span>
        </div>
      </div>
    );
  }
  
  return (
    <div className="cursor-pointer text-gray-700">
      <div className="text-xs font-medium leading-none whitespace-nowrap overflow-hidden">
        <span>{eventInfo.timeText}</span>
      </div>
      <div className="text-sm font-medium leading-4 whitespace-nowrap overflow-hidden">
        {eventInfo.event.title}
      </div>
    </div>
  );
}